(function(app, ng) {

    app.component("backButton",
        {
            templateUrl: "App/Components/BackButton/back-button.component.html",
            controller: backButtonController,
            bindings: {
                label: "@",
                fallback: "@",
                fallbackParams: "<"
            }
        });

    backButtonController.$inject = ["stateHistory"];
    function backButtonController(stateHistory) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                invoke: function() {
                    stateHistory.goBack($ctrl.fallback, $ctrl.fallbackParams);
                }
            });
    }

})(window.app, window.angular); //jshint ignore:line